import util from '../util';

export const EMPLOYEES = 'EMPLOYEES';
export const RESET_EMPLOYEE = 'RESET_EMPLOYEE';
export const CREATE_EMPLOYEE = 'CREATE_EMPLOYEE';
export const UPDATE_EMPLOYEE_PASSWORD = 'UPDATE_EMPLOYEE_PASSWORD';
export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';

export const EMPLOYEES_REQUEST = util.requestType(EMPLOYEES);
export const EMPLOYEES_SUCCESS = util.successType(EMPLOYEES);
export const EMPLOYEES_FAILURE = util.failureType(EMPLOYEES);

export const CREATE_EMPLOYEE_REQUEST = util.requestType(CREATE_EMPLOYEE);
export const CREATE_EMPLOYEE_SUCCESS = util.successType(CREATE_EMPLOYEE);
export const CREATE_EMPLOYEE_FAILURE = util.failureType(CREATE_EMPLOYEE);

export const UPDATE_EMPLOYEE_PASSWORD_REQUEST = util.requestType(
  UPDATE_EMPLOYEE_PASSWORD,
);
export const UPDATE_EMPLOYEE_PASSWORD_SUCCESS = util.successType(
  UPDATE_EMPLOYEE_PASSWORD,
);
export const UPDATE_EMPLOYEE_PASSWORD_FAILURE = util.failureType(
  UPDATE_EMPLOYEE_PASSWORD,
);

export const DELETE_EMPLOYEE_REQUEST = util.requestType(DELETE_EMPLOYEE);
export const DELETE_EMPLOYEE_SUCCESS = util.successType(DELETE_EMPLOYEE);
export const DELETE_EMPLOYEE_FAILURE = util.failureType(DELETE_EMPLOYEE);
